<template>
  <div class="userDetail">
    <div>
      <div class="userImg">
        <img :src="userData.img" alt="" v-if="userData.img">
        <img src="@/assets/head_img.jpg" alt="" v-else>
      </div>
      <div class="userEdit">
        <div>
          <p>
            <span>0</span>
            <span class="userText">粉丝</span>
          </p>
          <p>
            <span>54</span>
            <span class="userText">关注</span>
          </p>
          <p>
            <span>0</span>
            <span class="userText">获赞</span>
          </p>
        </div>
        <div class="userEditBtnContainer">
          <div class="userEditBtn">进入主页</div>
        </div>
      </div>
    </div>
    <div>
      <div class="userName">
        <h2>{{ truncatedUserId }}</h2>
        <img src="@/assets/svip.png" v-if="userData.svip.status != 1" alt="" class="vipImg">
      </div>
      <p v-if="userData.svip.status != 1">会员到期时间：{{userData.svip.expire}}</p>
      <p v-else>开通SVIP会员几十万部影片随意看</p>
    </div>
  </div>
  <div style="display: flex" class="payInfo">
    <div class="wallet">
      <div class="walletInfo" @click="$router.push('/user/pay')">
        <span>我的钱包</span>
        <span>{{balance}}</span>
      </div>
      <div class="userEditBtn"><img src="@/assets/hidden.png" alt=""></div>
    </div>
    <div class="payVip">
      <div class="payVipInfo" @click="$router.push('/user/upgrade')">
        <span>升级SVIP</span>
        <img src="@/assets/b_sivp.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "userDetail",
  props: ['userData'],
  computed: {
    truncatedUserId() {
      const maxLength = 10; // 设置最大长度
      if (this.userData.card.userid.length > maxLength) {
        return this.userData.card.userid.substring(0, maxLength) + '***';
      } else {
        return this.userData.card.userid;
      }
    },
    balance(){
      const remaining = this.userData.balance?.remaining||0
      return remaining.toFixed(2)
    },
  }
}
</script>

<style scoped lang="scss">
.userDetail {
  margin-top: -10px;
  background-color: white;
  padding: 2vw 3.333vw;

  div:nth-child(1) {
    display: flex;

    .userImg {
      margin-top: -10px;
      margin-right: 5.556vw;

      img {
        top: 50px;
        height: 23.611vw;
        width: 23.611vw;
        border-radius: 50%;
      }
    }

    .userEdit {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      div:nth-child(1) {
        display: flex;
        p {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          font-size: 3.611vw;
          color: black;
          position: relative; /* 使伪元素的定位相对于父元素 */
          .userText {
            color: #aaa;
          }
          &:nth-child(1)::after,
          &:nth-child(2)::after {
            content: "";
            position: absolute;
            right: 0;
            top: 50%; /* 定位到中间 */
            transform: translateY(-50%); /* 垂直居中 */
            height: 50%; /* 竖线的高度 */
            border-right: 0.278vw solid #ccc;
          }
        }
      }

      .userEditBtnContainer {
        display: flex;
        justify-content: center;
        padding: 0.556vw 2.778vw;
      }

      .userEditBtn {
        border: 0.278vw solid #fb7a9f;
        padding: 2vw 16vw; /* 增加按钮的内边距以使其变宽 */
        background-color: #fb7a9f; /* 设定背景颜色为主题颜色 */
        color: white; /* 设定字体颜色为白色 */
        display: flex;
        align-items: center;
        justify-content: center; /* 居中文字 */
        border-radius: 8vw; /* 修正单位 */
      }
    }
  }

  div:nth-child(2) {
    .userName {
      display: flex;
      align-items: center;
      h2 {
        margin: 2.778vw 0 0.01vw 0;
        font-weight: 300;
      }
    }
    p {
      padding: 0;
      color: #999;
      font-size: 3.5vw; /* 调整会员到期时间的字体大小 */
    }
  }

  .vipImg {
    height: 2.5vw;
    margin-left: 1vw;
  }
}
.payInfo {
  display: flex;
  background-color: white;
  div {
    margin: 1vw 2vw;
  }
  .wallet {
    flex: 1;
    display: flex;
    padding: 1vw 2vw;
    color: white;
    border-radius: 1.5vw;
    background-image: url('@/assets/wallte.png'); /* 添加背景图片 */
    background-size: cover; /* 使背景图片覆盖 */
    background-position: center; /* 使背景图片居中 */
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    max-width: 50vw;
    .walletInfo {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      span {
        display: block;
        font-size: 4vw;
      }
    }
    .userEditBtn {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      img {
        height: 4vw;
        width: 4vw;
      }
    }
  }
  .payVip {
    flex: 1;
    display: flex;
    padding: 1vw 2vw;
    color: white;
    border-radius: 1.5vw;
    background-image: url('@/assets/pay_vip.png'); /* 添加背景图片 */
    background-size: cover; /* 使背景图片覆盖 */
    background-position: center; /* 使背景图片居中 */
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    .payVipInfo {
      flex: 1;
      display: flex;
      align-items: center; /* Center align items vertically */
      justify-content: space-between; /* Space between elements */
      span {
        font-size: 4vw; /* Match the font size to align properly */
      }
      img {
        height: 6vw;
        margin-left: 1vw; /* Add margin to space out the image from the text */
      }
    }
  }
}
</style>
